<template>
  <div>loading...</div>
</template>
<script>
export default {
  name: "loading",
  mounted() {
    console.log("loading");
  },
};
</script>
